import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import { MapPinIcon } from 'lucide-react';
import 'leaflet/dist/leaflet.css';
// We need to handle Leaflet marker icons in React
const fixLeafletIcon = () => {
  // This is needed because Leaflet's default icon paths are challenged in React
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png'
  });
};
// Service locations with coordinates
const serviceLocations = [{
  name: 'Cape Coral (Our Location)',
  position: [26.5629, -81.9495],
  primary: true
}, {
  name: 'Fort Myers',
  position: [26.6406, -81.8723],
  primary: false
}, {
  name: 'Punta Gorda',
  position: [26.9298, -82.0454],
  primary: false
}, {
  name: 'Bonita Springs',
  position: [26.3398, -81.7787],
  primary: false
}];
// County center points (approximate)
const counties = [{
  name: 'Lee County',
  position: [26.5629, -81.9495],
  radius: 25000,
  color: '#3B82F6'
}, {
  name: 'Charlotte County',
  position: [26.9162, -82.0773],
  radius: 20000,
  color: '#3B82F6'
}, {
  name: 'Collier County',
  position: [26.142, -81.7948],
  radius: 25000,
  color: '#3B82F6'
}];
export const ServiceAreaMap = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    // Fix the Leaflet icon issue
    if (typeof L !== 'undefined') {
      fixLeafletIcon();
    }
  }, []);
  // Don't render the map on the server
  if (!isClient) {
    return <div className="flex justify-center items-center h-96 bg-gray-100 rounded-xl" data-id="element-305">
        <div className="flex items-center" data-id="element-306">
          <MapPinIcon className="animate-bounce mr-2 text-blue-600" data-id="element-307" />
          <span className="text-gray-600" data-id="element-308">Loading service area map...</span>
        </div>
      </div>;
  }
  return <div className="rounded-xl overflow-hidden shadow-xl" data-id="element-309">
      <div className="h-[500px] w-full" data-id="element-310">
        <MapContainer center={[26.5629, -81.9495]} // Cape Coral coordinates
      zoom={9} style={{
        height: '100%',
        width: '100%'
      }} className="z-0" data-id="element-311">
          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-312" />
          {/* Add county service areas */}
          {counties.map(county => <Circle key={county.name} center={county.position} radius={county.radius} pathOptions={{
          fillColor: county.color,
          fillOpacity: 0.1,
          weight: 2,
          color: county.color,
          opacity: 0.5
        }} data-id="element-313">
              <Popup data-id="element-314">
                <div className="font-medium" data-id="element-315">{county.name} - Service Area</div>
              </Popup>
            </Circle>)}
          {/* Add markers for each location */}
          {serviceLocations.map(location => <Marker key={location.name} position={location.position} title={location.name} data-id="element-316">
              <Popup data-id="element-317">
                <div className="font-medium" data-id="element-318">
                  {location.primary ? <strong className="text-blue-600" data-id="element-319">{location.name}</strong> : location.name}
                </div>
              </Popup>
            </Marker>)}
        </MapContainer>
      </div>
      <div className="bg-white p-4" data-id="element-320">
        <h3 className="font-bold text-lg text-gray-800 mb-2" data-id="element-321">
          Our Service Areas
        </h3>
        <p className="text-gray-600" data-id="element-322">
          AIR-MAZING AIR, INC. proudly serves all of Southwest Florida,
          including Lee, Charlotte, and Collier counties. Our central location
          in Cape Coral allows us to quickly respond to service calls throughout
          the region.
        </p>
      </div>
    </div>;
};